import { environment } from '../../environments/environment';

export class ReportingAPiBase {
  public baseUrl = environment.reportsApi;
}
